// 経験・スキル画面の開閉制御と選択制御（mypage / admin 共通）
//
// 開閉
// - 就職状況 select: [data-role="employment-status"][data-work-experienced-values="working resigning"]
//   値が data-work-experienced-values に含まれるときだけ .js-work-experienced-fields を表示する
// - 経験業種のコンテナ: .js-skill-industries[data-exp-key-by-id='{"1":"general",...}']
//   チェックされた業種に対応する .js-exp-block[data-exp-key] を表示する（上の欄が表示中のときだけ）
// - 開閉は hidden 属性の付け外しのみで、隠した欄の値は触らない。初期状態はサーバー側で描画済み
//
// 選択制御（データの不整合を防ぐ）
// - 最終職年収・経験社数・経験業種のいずれかに入力があるときは、就職状況を「就業経験無し」
//   （data-work-experienced-values 以外の値）に変更できないよう option を disabled にする
// - 対応する勤務経験ブロック（職種・経験年数）に入力がある経験業種はチェックを外せない
//   （disabled にすると送信値が落ちるので、click をキャンセルし is-locked クラスで見た目だけ無効化する）
$(function () {
  const SELECT_SELECTOR = '[data-role="employment-status"]'
  const INDUSTRIES_SELECTOR = '.js-skill-industries'
  const INDUSTRY_CHECKBOX_SELECTOR = INDUSTRIES_SELECTOR + ' input[type="checkbox"]'
  const WORK_EXPERIENCED_FIELDS_SELECTOR = '.js-work-experienced-fields'
  const EXP_BLOCK_SELECTOR = '.js-exp-block'
  const INPUT_SELECTOR = 'input:not([type="hidden"]), select, textarea'
  const LOCKED_CLASS = 'is-locked'

  function hasValue(el) {
    if (el.type === 'checkbox' || el.type === 'radio') return el.checked
    return String(el.value).trim() !== ''
  }

  // 最終職年収・経験社数・経験業種（表示中の欄）のいずれかに入力があるか
  function hasWorkExperiencedInput() {
    return $(WORK_EXPERIENCED_FIELDS_SELECTOR).find(INPUT_SELECTOR).filter(':visible').toArray().some(hasValue)
  }

  // 勤務経験ブロック（職種・経験年数）に入力があるか
  function expBlockHasInput(key) {
    return $(EXP_BLOCK_SELECTOR + '[data-exp-key="' + key + '"]').find(INPUT_SELECTOR).toArray().some(hasValue)
  }

  function refresh() {
    const $select = $(SELECT_SELECTOR)
    if (!$select.length) return

    const values = String($select.data('workExperiencedValues') || '').split(/\s+/)
    const workExperienced = values.indexOf($select.val()) !== -1
    $(WORK_EXPERIENCED_FIELDS_SELECTOR).prop('hidden', !workExperienced)

    const $industries = $(INDUSTRIES_SELECTOR)
    const keyById = $industries.data('expKeyById') || {}
    const visibleKeys = {}
    if (workExperienced) {
      $industries.find('input[type="checkbox"]:checked').each(function () {
        const key = keyById[this.value]
        if (key) visibleKeys[key] = true
      })
    }
    $(EXP_BLOCK_SELECTOR).each(function () {
      $(this).prop('hidden', !visibleKeys[this.dataset.expKey])
    })

    // 対応ブロックに入力がある業種はチェックを外せない
    $industries.find('input[type="checkbox"]').each(function () {
      const key = keyById[this.value]
      const locked = workExperienced && this.checked && !!key && expBlockHasInput(key)
      this.dataset.locked = locked ? 'true' : ''
      $(this).closest('.form-item, .form-check').toggleClass(LOCKED_CLASS, locked)
    })

    // 現在の選択が就業中・離職中で、年収・経験社数・経験業種に入力があるときだけ「就業経験無し」を選べなくする
    // （選択中の option を disabled にすると送信値が落ちるため、就業経験無しを選択中のときは触らない）
    const lock = workExperienced && hasWorkExperiencedInput()
    $select.find('option').each(function () {
      if (values.indexOf(this.value) === -1) this.disabled = lock
    })
  }

  refresh()
  $(document).on('change', SELECT_SELECTOR + ', ' + INDUSTRY_CHECKBOX_SELECTOR, refresh)
  $(document).on('input change', WORK_EXPERIENCED_FIELDS_SELECTOR + ' ' + INPUT_SELECTOR + ', ' + EXP_BLOCK_SELECTOR + ' ' + INPUT_SELECTOR, refresh)
  // ロック中の業種はクリック（ラベル経由も含む）をキャンセルしてチェックを維持する
  $(document).on('click', INDUSTRY_CHECKBOX_SELECTOR, function (e) {
    if (this.dataset.locked === 'true') e.preventDefault()
  })
})
